<template>
  <div class="table-page">
    <el-button
        type="primary"
        size="mini"
        icon="el-icon-arrow-left"
        @click="$router.push({ path: '/statement/projects' })"
        style="margin-right: 15px"
    >返回
    </el-button
    >
    <el-button-group>
      <el-button
          type="primary"
          @click="addListBtn"
          :disabled="verifyInfos.status === 1 && verifyInfos.typ === 'final'"
      >添加条目
      </el-button
      >
      <el-button
          type="primary"
          @click="delList"
          :disabled="
          multipleSelection.length <= 0 ||
          (verifyInfos.status === 1 && verifyInfos.typ === 'final')
        "
      >删除条目
      </el-button
      >
      <el-button type="primary" icon="el-icon-download" @click="filesExport"
      >导出结算单
      </el-button
      >
    </el-button-group>

    <el-button-group style="margin-left: 35px">
      <el-button
          type="info"
          size="small"
          @click="showCostListBtn"
          :disabled="verifyInfos.status === 1 && verifyInfos.typ === 'final'"
      >添加/修改项目费用清单
      </el-button
      >
      <el-button
          type="info"
          size="small"
          @click="showProfitCaculateBtn"
          :disabled="verifyInfos.status === 1 && verifyInfos.typ === 'final'"
      >添加/修改利润核算单
      </el-button
      >
    </el-button-group>
    <el-button-group style="float: right; margin-right: 85px" v-show="!userInfo.is_admin">
      <el-button
          v-if="verifyInfos.status === 0 && verifyInfos.typ === 'budget'"
          type="warning"
          size="small"
      >预算审核中
      </el-button
      >
      <div v-else-if="verifyInfos.status === -1 && verifyInfos.typ === 'budget'">
        <el-tooltip placement="bottom">
          <div slot="content">{{ verifyInfos.remark }}</div>
          <el-button type="danger" size="small">预算审核失败</el-button>
        </el-tooltip>
        <el-button size="small" type="primary" @click="submitVerifier('budget')"
        >重新提交审核
        </el-button
        >
      </div>
      <el-button
          v-else-if="verifyInfos.status === 1 && verifyInfos.typ === 'budget'"
          type="primary"
          size="small"
          @click="submitVerifier('final')"
      >提交决算审核
      </el-button
      >
      <el-button
          v-else-if="verifyInfos.status === 0 && verifyInfos.typ === 'final'"
          type="warning"
          size="small"
      >决算审核中
      </el-button
      >
      <div v-else-if="verifyInfos.status === -1 && verifyInfos.typ === 'final'">
        <el-tooltip placement="bottom">
          <div slot="content">{{ verifyInfos.remark }}</div>
          <el-button type="danger" size="small">决算审核失败</el-button>
        </el-tooltip>
        <el-button size="small" type="primary" @click="submitVerifier('final')"
        >重新提交审核
        </el-button
        >
      </div>
      <el-button
          v-else-if="verifyInfos.status === 1 && verifyInfos.typ === 'final'"
          type="success"
          size="small"
      >决算审核通过
      </el-button
      >
      <el-button v-else type="primary" size="small" @click="submitVerifier('budget')"
      >提交预算审核
      </el-button
      >
    </el-button-group>
    <div class="el-table el-table--border el-table--small">
      <div class="el-table__body-wrapper is-scrolling-left">
        <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            class="el-table__body"
            style="width: 100%"
        >
          <tbody>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td rowspan="1" colspan="6" class="el-table__cell">
              <div class="cell td-title">项目预算报价单</div>
            </td>
            <td rowspan="1" colspan="5" class="el-table__cell">
              <div class="cell td-title"><h3>项目执行费用清单</h3></div>
            </td>
            <td rowspan="1" colspan="5" class="el-table__cell">
              <div class="cell td-title"><h3>项目利润核算单</h3></div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell td-head">会议名称:</div>
            </td>
            <td rowspan="2" colspan="6" class="el-table__cell">
              <div class="cell td-title">{{ projectForm.meet_name }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">无票合计</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ costListForm.total_no_ticket }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">公务卡支出</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ totalForm.totalCostBusinessCard }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">无票合计</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ profitCaculateForm.total_no_ticket }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">税率(选)</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{ (profitCaculateForm.tax_rate * 100).toFixed(1) }}%
              </div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{ (totalForm.totalAmount * profitCaculateForm.tax_rate).toFixed(2) }}
              </div>
            </td>
          </tr>

          <tr class="el-table__row">
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">现金借款</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ costListForm.cash_borrow }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">信用卡借款</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ costListForm.credit_borrow }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">抵扣金额</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ profitCaculateForm.deduct_amount }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">坏账准备</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{ (profitCaculateForm.bad_deb * 100).toFixed(1) }}%
              </div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{ (totalForm.totalAmount * profitCaculateForm.bad_deb).toFixed(2) }}
              </div>
            </td>
          </tr>

          <tr class="el-table__row">
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">会议时间:</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.meet_time }}</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell td-head">承接单位</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.company }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">现金支出</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ totalForm.totalCostCash }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">银行汇款</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ costListForm.bank_tarnsfer }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">已收金额</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ profitCaculateForm.received_amount }}</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell td-head">无票税金</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{
                  (
                      (costListForm.total_no_ticket +
                          profitCaculateForm.total_no_ticket) *
                      profitCaculateForm.noticket_tax_rate
                  ).toFixed(2)
                }}
              </div>
            </td>
          </tr>

          <tr class="el-table__row">
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">会议地点:</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.meet_addr }}</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell td-head">项目负责人</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.user.username }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">现金还款</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{
                  (costListForm.cash_borrow - totalForm.totalCostCash).toFixed(
                      2
                  )
                }}
              </div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">会议编号</div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.meet_num }}</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell td-head">未收金额</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{
                  (totalForm.totalAmount - profitCaculateForm.received_amount).toFixed(
                      2
                  )
                }}
              </div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell td-head">未付金额</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">{{ totalForm.totalGauge }}</div>
            </td>
          </tr>

          <tr class="el-table__row">
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell td-head">人数:</div>
            </td>
            <td rowspan="2" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.attendance }}</div>
            </td>
            <td rowspan="2" colspan="2" class="el-table__cell">
              <div class="cell td-head">联系电话</div>
            </td>
            <td rowspan="2" colspan="2" class="el-table__cell">
              <div class="cell">{{ projectForm.user.mobile }}</div>
            </td>
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell td-head">已付合计</div>
            </td>
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell">{{ totalForm.totalCostDetail }}</div>
            </td>
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell td-head">现金报账时间</div>
            </td>
            <td rowspan="2" colspan="2" class="el-table__cell">
              <div class="cell">{{ costListForm.cash_expense_time }}</div>
            </td>
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell td-head">应收合计</div>
            </td>
            <td rowspan="2" colspan="1" class="el-table__cell">
              <div class="cell">
                {{ totalForm.totalAmount }}
              </div>
            </td>
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell td-head">净利润</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{
                  (
                      totalForm.totalAmount -
                      totalForm.totalCost -
                      totalForm.totalAmount * profitCaculateForm.tax_rate -
                      totalForm.totalAmount * profitCaculateForm.bad_deb -
                      (costListForm.total_no_ticket +
                          profitCaculateForm.total_no_ticket) *
                      profitCaculateForm.noticket_tax_rate +
                      profitCaculateForm.deduct_amount
                  ).toFixed(2)
                }}
              </div>
            </td>
          </tr>

          <tr class="el-table__row">
            <td rowspan="1" colspan="2" class="el-table__cell">
              <div class="cell td-head">利润率</div>
            </td>
            <td rowspan="1" colspan="1" class="el-table__cell">
              <div class="cell">
                {{
                  (
                      ((totalForm.totalAmount -
                          totalForm.totalCost -
                          totalForm.totalAmount * profitCaculateForm.tax_rate -
                          totalForm.totalAmount * profitCaculateForm.bad_deb -
                          (costListForm.total_no_ticket +
                              profitCaculateForm.total_no_ticket) *
                          profitCaculateForm.noticket_tax_rate +
                          profitCaculateForm.deduct_amount) /
                          totalForm.totalAmount) *
                      100
                  ).toFixed(2)
                }}%
              </div>
            </td>
          </tr>

          <!---->
          </tbody>
        </table>
        <!----><!---->
      </div>
    </div>

    <el-table
        size="small"
        style="width: 100%"
        :data="tableData"
        max-height="560"
        :summary-method="getSummaries"
        show-summary
        @selection-change="handleSelectionChange"
        @row-dblclick="rowDbClickEdit"
    >
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column>
        <template slot="header">
          <span style="font-size: 18px; color: #000000">会议需求</span>
        </template>
        <el-table-column
            label="服务类别"
            prop="meet_demand.service_type"
        ></el-table-column>
        <el-table-column
            label="服务描述"
            prop="meet_demand.service_desc"
        ></el-table-column>
        <el-table-column label="备注" prop="meet_demand.service_remark"></el-table-column>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <span style="font-size: 18px; color: #000000">结算报价</span>
        </template>
        <el-table-column label="数量" prop="settlement.count"></el-table-column>
        <el-table-column label="单位" prop="settlement.unit"></el-table-column>
        <el-table-column label="单价" prop="settlement.unit_price"></el-table-column>
        <el-table-column>
          <template slot="header">
            <span style="color: #f56c6c">合计</span>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.settlement.total }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <span style="font-size: 18px; color: #000000">费用明细</span>
        </template>
        <el-table-column label="现金" prop="cost_detail.cash"></el-table-column>
        <el-table-column
            label="公务卡"
            prop="cost_detail.business_card"
        ></el-table-column>
        <el-table-column>
          <template slot="header">
            <span style="color: #f56c6c">合计</span>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.cost_detail.total }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="cost_detail.remark"></el-table-column>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <span style="font-size: 18px; color: #000000">计调明细</span>
        </template>
        <el-table-column label="数量" prop="gauge_detail.count"></el-table-column>
        <el-table-column label="单价" prop="gauge_detail.unit_price"></el-table-column>
        <el-table-column>
          <template slot="header">
            <span style="color: #f56c6c">合计</span>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.gauge_detail.total }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="备注(供应商)"
            prop="gauge_detail.remark"
        ></el-table-column>
      </el-table-column>
      <el-table-column label="">
        <el-table-column>
          <template slot="header">
            <span style="color: #f56c6c">成本合计</span>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.cost }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="">
        <el-table-column>
          <template slot="header">
            <span style="color: #f56c6c">利润</span>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.profit }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <div class="el-table el-table--border el-table--small">
      <div class="el-table__footer-wrapper" style="">
        <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            class="el-table__footer"
            style="width: 100%"
        >
          <colgroup>
            <col name="el-table_19_column_433" width="45"/>
            <col name="el-table_19_column_434_column_435" width="91"/>
            <col name="el-table_19_column_434_column_436" width="91"/>
            <col name="el-table_19_column_434_column_437" width="91"/>
            <col name="el-table_19_column_438_column_439" width="91"/>
            <col name="el-table_19_column_438_column_440" width="91"/>
            <col name="el-table_19_column_438_column_441" width="91"/>
            <col name="el-table_19_column_438_column_442" width="91"/>
            <col name="el-table_19_column_443_column_444" width="91"/>
            <col name="el-table_19_column_443_column_445" width="91"/>
            <col name="el-table_19_column_443_column_446" width="91"/>
            <col name="el-table_19_column_443_column_447" width="91"/>
            <col name="el-table_19_column_448_column_449" width="91"/>
            <col name="el-table_19_column_448_column_450" width="91"/>
            <col name="el-table_19_column_448_column_451" width="91"/>
            <col name="el-table_19_column_448_column_452" width="91"/>
            <col name="el-table_19_column_453_column_454" width="91"/>
            <col name="el-table_19_column_455_column_456" width="91"/>
            <col name="gutter" width="0"/>
          </colgroup>
          <tbody class="has-gutter">
          <tr>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell">服务费</div>
            </td>

            <td
                colspan="2"
                rowspan="1"
                class="el-table__cell"
                @click="serviceRateClick"
            >
              <div class="cell td-center">
                  <span v-if="!serviceRateOn"
                  >{{
                      projectForm.service_rate > 0
                          ? (projectForm.service_rate * 100).toFixed(1)
                          : 0
                    }}%</span
                  >
                <el-input-number
                    @keyup.enter.native="updateProjectRate"
                    :precision="3"
                    :step="0.002"
                    :max="1"
                    v-else
                    size="mini"
                    :controls="false"
                    placeholder="点Enter键修改"
                    @blur="serviceRateOn = false"
                    v-model="projectForm.service_rate"
                >
                </el-input-number>
              </div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell">
                {{ totalForm.totalServiceAmount }}
              </div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <th class="el-table__cell gutter" style="width: 0px; display: none"></th>
          </tr>
          <tr>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell">税金</div>
            </td>
            <td
                colspan="2"
                rowspan="1"
                class="el-table__cell"
                @click="taxRateClick"
            >
              <div class="cell td-center">
                  <span v-if="!taxRateOn"
                  >{{
                      projectForm.tax_rate > 0
                          ? (projectForm.tax_rate * 100).toFixed(1)
                          : 0
                    }}%</span
                  >
                <el-input-number
                    @keyup.enter.native="updateProjectRate"
                    :precision="3"
                    :step="0.002"
                    :max="1"
                    v-else
                    size="mini"
                    :controls="false"
                    placeholder="点Enter键修改"
                    @blur="taxRateOn = false"
                    v-model="projectForm.tax_rate"
                >
                </el-input-number>
              </div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell">
                {{
                  (
                      (totalForm.totalSettlement + totalForm.totalServiceAmount) *
                      projectForm.tax_rate
                  ).toFixed(2)
                }}
              </div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <th class="el-table__cell gutter" style="width: 0px; display: none"></th>
          </tr>
          <tr>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell">总价</div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell">
                {{ totalForm.totalAmount }}
              </div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <td colspan="1" rowspan="1" class="el-table__cell">
              <div class="cell"></div>
            </td>
            <th class="el-table__cell gutter" style="width: 0px; display: none"></th>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <el-dialog
        title="添加/修改项目费用清单"
        :visible.sync="showCostList"
        :close-on-click-modal="false"
        width="50%"
        center
    >
      <el-form :model="costListForm" ref="costListForm" label-width="100px">
        <el-form-item label="无票合计">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="costListForm.total_no_ticket"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="现金借款">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="costListForm.cash_borrow"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="信用卡借款">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="costListForm.credit_borrow">
          </el-input-number>
        </el-form-item>
        <el-form-item label="银行汇款">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="costListForm.bank_tarnsfer">
          </el-input-number>
        </el-form-item>
        <el-form-item label="现金报账时间">
          <el-date-picker
              v-model="costListForm.cash_expense_time"
              type="date"
              value-format="yyyy/M/dd"
              placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addCostList">确定</el-button>
          <el-button @click="cancelCostList">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
        title="添加/修改利润核算单"
        :visible.sync="showProfitCaculate"
        width="30%"
        center
        :close-on-click-modal="false"
    >
      <el-form :model="profitCaculateForm" ref="profitCaculateForm" label-width="100px">
        <el-form-item label="无票合计">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="profitCaculateForm.total_no_ticket"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="抵扣金额">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="profitCaculateForm.deduct_amount"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="已收金额">
          <el-input-number
              :precision="2"
              :step="0.5"
              v-model="profitCaculateForm.received_amount"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="税率">
          <el-input-number
              :precision="3"
              :step="0.002"
              :max="1"
              v-model="profitCaculateForm.tax_rate"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="坏账准备率">
          <el-input-number
              :precision="3"
              :step="0.002"
              :max="1"
              v-model="profitCaculateForm.bad_deb"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="无票税金率">
          <el-input-number
              :precision="3"
              :step="0.002"
              :max="1"
              v-model="profitCaculateForm.noticket_tax_rate"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addProfitCaculateList">确定</el-button>
          <el-button @click="cancelProfitCaculate">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <div style="margin-top: 25px"></div>
  </div>
</template>

<script>
import {getUserInfo} from "../utils/utils.js";

export default {
  data() {
    return {
      userInfo: {},
      verifyInfos: {},
      tableData: [],
      project_id: null,
      multipleSelection: [],
      showCostList: false,
      showProfitCaculate: false,
      costListForm: {
        project_id: null,
        total_no_ticket: 0.0,
        cash_borrow: 0.0,
        credit_borrow: 0.0,
        bank_tarnsfer: 0.0,
        cash_expense_time: "",
      },
      profitCaculateForm: {
        project_id: null,
        total_no_ticket: 0.0,
        deduct_amount: 0.0,
        received_amount: 0.0,
        tax_rate: 0.0,
        bad_deb: 0.0,
        noticket_tax_rate: 0.0,
      },
      projectForm: {
        user: {},
        project_id: null,
        meet_name: "",
        meet_num: "",
        meet_time: "",
        company: "",
        meet_addr: "",
        attendance: 0,
        service_rate: 0.0,
        tax_rate: 0.0,
        desc: "",
      },
      serviceRateOn: false,
      taxRateOn: false,
      // 报价单的总合计
      totalForm: {
        totalAmount: 0, // 总价
        totalSettlement: 0, // 结算报价总合计
        totalCostDetail: 0, // 费用明细总合计
        totalCostCash: 0, // 费用现金总合计
        totalCostBusinessCard: 0, // 费用公务卡总合计
        totalGauge: 0, // 计调总合计
        totalCost: 0, // 成本总合计
        totalProfit: 0, // 利润总合计
        totalServiceAmount: 0, // 总服务费
      },
    };
  },
  methods: {
    taxRateClick() {
      let that = this;
      if (that.verifyInfos.status === 1 && that.verifyInfos.typ === "final") {
        that.taxRateOn = false;
      } else {
        that.taxRateOn = true;
      }
    },
    serviceRateClick() {
      let that = this;
      if (that.verifyInfos.status === 1 && that.verifyInfos.typ === "final") {
        that.serviceRateOn = false;
      } else {
        that.serviceRateOn = true;
      }
    },
    submitVerifier(typ) {
      let that = this;
      that.$axios
          .post(that.host + "/api/projects/" + typ + "/verifier", {
            project_id: that.project_id,
          })
          .then((res) => {
            that.$message.success("提交成功");
            that.loadVerifier();
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    filesExport() {
      let that = this;
      that.fullscreenLoading = true;
      that.$axios
          .get(that.host + "/api/settlement/exporter?project_id=" + that.project_id, {
            responseType: "blob",
            headers: {"Cache-Control": "no-cache"},
          })
          .then((res) => {
            let blob = new Blob([res.data]);
            let link = document.createElement("a");
            link.download = "结算单.xlsx";
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            that.fullscreenLoading = false;
          })
          .catch((err) => {
            let resData = err.data;
            if(err.data.type == "application/json"){
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                let jsonData = JSON.parse(fileReader.result)
                // 后台信息
                that.$message.error(jsonData.errmsg);
                that.fullscreenLoading = false;
              }
              fileReader.readAsText(resData);
            }
          });
    },
    loadVerifier() {
      let that = this;
      that.$axios
          .get(that.host + "/api/projects/verifier?project_id=" + that.project_id)
          .then((res) => {
            that.verifyInfos = res.data.results;
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    updateProjectRate() {
      let that = this;
      that.$axios
          .post(that.host + "/api/projects/rate", that.projectForm)
          .then((res) => {
            that.$message.success("修改成功");
            that.serviceRateOn = false;
            that.taxRateOn = false;
            that.loadTotalForm(that.tableData);
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    cancelCostList() {
      let that = this;
      that.showCostList = false;
      that.loadCostList();
    },
    cancelProfitCaculate() {
      let that = this;
      that.showProfitCaculate = false;
      that.loadProfitCaculateList();
    },
    loadProjectDetail(project_id) {
      // 加载项目信息
      return new Promise((resolve, reject) => {
        let that = this;
        that.$axios
            .get(that.host + "/api/projects?project_id=" + project_id)
            .then((res) => {
              let results = res.data.results;
              that.projectForm = results;
              resolve();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
              reject;
            });
      });
    },
    showProfitCaculateBtn() {
      let that = this;
      that.showProfitCaculate = true;
      that.loadProfitCaculateList();
    },
    loadProfitCaculateList() {
      let that = this;
      that.$axios
          .get(that.host + "/api/profit/caculate/lists?project_id=" + that.project_id)
          .then((res) => {
            that.profitCaculateForm = res.data.results;
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    showCostListBtn() {
      let that = this;
      that.showCostList = true;
      that.loadCostList();
    },
    loadCostList() {
      let that = this;
      that.$axios
          .get(that.host + "/api/execute/cost/lists?project_id=" + that.project_id)
          .then((res) => {
            that.costListForm = res.data.results;
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    addProfitCaculateList() {
      // 添加 项目利润核算单
      let that = this;
      if (!that.profitCaculateForm.project_id) {
        that.$message.warning("项目ID不存在");
        that.$router.push({
          path: "/statement/projects",
        });
        return;
      }
      that.$axios
          .post(that.host + "/api/profit/caculate/lists", that.profitCaculateForm)
          .then((res) => {
            that.$message.success("添加/修改项目利润核算单成功");
            that.showProfitCaculate = false;
            that.$router.push({
              path: "/statement/list",
            });
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    addCostList() {
      // 添加项目执行费用清单
      let that = this;
      if (!that.costListForm.project_id) {
        that.$message.warning("项目ID不存在");
        that.$router.push({
          path: "/statement/projects",
        });
        return;
      }
      that.$axios
          .post(that.host + "/api/execute/cost/lists", that.costListForm)
          .then((res) => {
            that.$message.success("添加/修改项目执行费用清单成功");
            that.showCostList = false;
            that.$router.push({
              path: "/statement/list",
            });
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
    goBack() {
      console.log("go back");
    },
    delList() {
      // 删除清单
      let that = this;
      that
          .$confirm("此操作将永久删除该清单信息, 是否继续?", "删除清单", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
          .then(() => {
            let list_ids = [];
            for (let i = 0; i < that.multipleSelection.length; i++) {
              let item = that.multipleSelection[i];
              list_ids.push(item.list_id);
            }
            that.$axios
                .delete(that.host + "/api/lists/batch_del", {
                  data: {
                    list_ids: list_ids,
                    project_id: parseInt(that.project_id),
                  },
                })
                .then((res) => {
                  that.$message.success("删除清单信息成功");
                  that.loadStatement(that.project_id);
                })
                .catch((err) => {
                  that.$message.error(err.data.errmsg);
                });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    deleteList(val) {
      let that = this;
      that
          .$confirm("此操作将永久删除该清单信息, 是否继续?", "删除清单", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
          .then(() => {
            that.$axios
                .delete(that.host + "/api/lists", {
                  data: {
                    list_id: val.list_id,
                    project_id: parseInt(that.project_id),
                  },
                })
                .then((res) => {
                  that.$message.success("删除清单信息成功");
                  that.loadStatement(that.project_id);
                })
                .catch((err) => {
                  that.$message.error(err.data.errmsg);
                });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    rowDbClickEdit(val) {
      let that = this;
      if (that.verifyInfos.status === 1 && that.verifyInfos.typ === "final") {
        return;
      } else {
        that.$router.push({
          path: "/statement/detail",
          query: {
            project_id: that.project_id,
            meet_time: that.projectForm.meet_time,
            list_id: val.list_id,
          },
        });
      }
    },
    getSummaries(param) {
      // 表格合计
      let that = this;
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "Total";
        }
        // 结算合计
        if (index === 7) {
          sums[index] = that.totalForm.totalSettlement;
        }
        // 现金合计
        if (index === 8) {
          sums[index] = that.totalForm.totalCostCash;
        }
        // 公务卡合计
        if (index === 9) {
          sums[index] = that.totalForm.totalCostBusinessCard;
        }
        // 费用明细合计
        if (index === 10) {
          sums[index] = that.totalForm.totalCostDetail;
        }
        // 计调合计
        if (index === 14) {
          sums[index] = that.totalForm.totalGauge;
        }
        // 成本合计
        if (index === 16) {
          sums[index] = that.totalForm.totalCost;
        }
        // 利润合计
        if (index === 17) {
          sums[index] = that.totalForm.totalProfit;
        }
      });
      return sums;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addListBtn() {
      let that = this;
      that.$router.push({
        path: "/statement/detail",
        query: {
          project_id: that.project_id,
          meet_time: that.projectForm.meet_time,
        },
      });
    },
    loadTotalForm(datas) {
      let that = this;
      let totalSettlement = 0; // 结算报价总合计
      let totalCostDetail = 0; // 费用明细总合计
      let totalCostCash = 0; // 费用现金总合计
      let totalCostBusinessCard = 0; // 费用公务卡总合计
      let totalGauge = 0; // 计调总合计
      let totalCost = 0; // 成本总合计
      let totalProfit = 0; // 利润总合计
      let totalServiceAmount = 0; // 总服务费
      for (let i = 0; i < datas.length; i++) {
        let item = datas[i];
        totalSettlement += item.settlement.total;
        totalCostDetail += item.cost_detail.total;
        totalCostCash += item.cost_detail.cash;
        totalCostBusinessCard += item.cost_detail.business_card;
        totalGauge += item.gauge_detail.total;
        totalCost += item.cost;
        totalProfit += item.profit;
        // 计算总服务费
        if (item.settlement.is_caculate) {
          totalServiceAmount += item.settlement.total * that.projectForm.service_rate;
        }
      }
      that.totalForm.totalSettlement = parseFloat(totalSettlement.toFixed(2));
      that.totalForm.totalCostDetail = parseFloat(totalCostDetail.toFixed(2));
      that.totalForm.totalCostCash = parseFloat(totalCostCash.toFixed(2));
      that.totalForm.totalCostBusinessCard = parseFloat(totalCostBusinessCard.toFixed(2));
      that.totalForm.totalGauge = parseFloat(totalGauge.toFixed(2));
      that.totalForm.totalCost = parseFloat(totalCost.toFixed(2));
      that.totalForm.totalProfit = parseFloat(totalProfit.toFixed(2));
      that.totalForm.totalServiceAmount = parseFloat(totalServiceAmount.toFixed(2));
      // 计算总价
      that.totalForm.totalAmount =
          that.totalForm.totalSettlement +
          that.totalForm.totalServiceAmount +
          (that.totalForm.totalSettlement + that.totalForm.totalServiceAmount) *
          that.projectForm.tax_rate;
      that.totalForm.totalAmount = parseFloat(that.totalForm.totalAmount.toFixed(2));
    },
    loadStatement(project_id) {
      // 加载项目清单
      let that = this;
      that.$axios
          .get(that.host + "/api/lists?project_id=" + project_id)
          .then((res) => {
            let tableData = [];
            let results = res.data.results;

            for (let i = 0; i < results.length; i++) {
              let result = results[i];
              let cost_detail = result.cost_detail;
              let gauge_detail = result.gauge_detail;
              let settlement = result.settlement;
              cost_detail.total = parseFloat(
                  (cost_detail.business_card + cost_detail.cash).toFixed(2)
              );
              gauge_detail.total = parseFloat(
                  (gauge_detail.count * gauge_detail.unit_price).toFixed(2)
              );
              settlement.total = parseFloat(
                  (settlement.count * settlement.unit_price).toFixed(2)
              );
              result.cost_detail = cost_detail;
              result.gauge_detail = gauge_detail;
              result.settlement = settlement;
              result.cost = parseFloat((cost_detail.total + gauge_detail.total).toFixed(2));
              result.profit = parseFloat(
                  (settlement.total - (cost_detail.total + gauge_detail.total)).toFixed(2)
              );
              tableData.push(result);
            }
            that.tableData = tableData;
            that.loadTotalForm(tableData);
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
  },
  mounted() {
    let that = this;
    let project_id = that.$route.query.project_id;
    if (!project_id) {
      that.$router.go(-1);
      return;
    }
    getUserInfo().then((res) => {
      that.userInfo = res;
      if (!that.userInfo.is_admin) {
        that.loadVerifier();
      }
    });
    that.project_id = parseInt(project_id);
    that.costListForm.project_id = parseInt(project_id);
    that.profitCaculateForm.project_id = parseInt(project_id);
    that.loadProjectDetail(project_id).then(() => {
      that.loadStatement(project_id);
    });
    that.loadProfitCaculateList();
    that.loadCostList();
  },
};
</script>

<style>
.table-page {
  padding: 0 30px 0 30px;
}

.td-title {
  font-size: 18px;
  color: #000000;
  text-align: center;
  font-weight: 600;
}

.td-center {
  text-align: center;
}

.td-head {
  font-size: 15px;
  color: #000000;
  font-weight: 600;
}
</style>
